<template>
  <div class="poll" :class="afterVoteMessage ? 'closed' : ''">
    <div
      v-if="pollQuestion"
      class="poll-title">
      <span>Encuesta</span>
      <strong>{{ pollQuestion }}</strong>
    </div>
    <div :class="isTextTemplate ? 'poll-text' : 'poll-image' ">
      <edi-poll-option
        v-for="(option, index) in pollResults"
        :option="option"
        :template="template"
        :show-results="showResults"
        :show-number-votes-per-response="showNumberVotesPerResponse"
        :key="index"
        :active="option.optionId === activeOption"
        :is-text-template="isTextTemplate"
        :loading="loading"
        @click="onVoteOption"
      />
    </div>

    <div
      v-if="showNumberVotes"
      class="poll-votes">
      {{ totalVotes }}
    </div>

    <div class="poll-message" v-if="afterVoteMessage">
      {{ afterVoteMessage }}
    </div>

  </div>
</template>

<script>
  import EdiPollOption from "./EdiPollOption";
  import Cookies from 'js-cookie';

  import api, {TEMPLATE_TEXT, TEMPLATE_IMAGE} from "./api";

  const VOTED_POLL = 'Brainhub:Poll_';

  // https://mgr.bitban.com/issues/67892
  export default {
    name: 'edi-poll',
    components: {EdiPollOption},
    props: {
      pollId: Number,
      pollQuestion: String,
      thanksText: String,
      numberVotes: Number,
      options: Array,
      showNumberVotes: Number,
      showNumberVotesPerResponse: Number,
      showResults: Number,
      template: {
        type: String,
        validator: (v) => [TEMPLATE_TEXT, TEMPLATE_IMAGE].includes(v)
      }
    },
    data() {
      return {
        pollResults: this.options,
        activeOption: null,
        afterVoteMessage: '',
        loading: false
      }
    },
    methods: {
      hasAlreadyVoted() {
        return !!Cookies.get(this.votedPollCookieName);
      },
      onVoteOption({optionId}) {
        if (!this.hasAlreadyVoted()) {
          this.loading = true;
          this.activeOption = optionId;
          api
            .vote(this.pollId, optionId)
            .then(res => {
              const {results, afterVoteMessage} = res;
              this.pollResults = results;
              this.afterVoteMessage = afterVoteMessage;
              Cookies.set(this.votedPollCookieName, optionId);
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    computed: {
      isTextTemplate() {
        return this.template === TEMPLATE_TEXT;
      },
      votedPollCookieName() {
        return VOTED_POLL + this.pollId;
      },
      totalVotes() {
        const total = this.pollResults.reduce((prev, curr) => prev + curr.numVotes, 0);
        return `${total} ${total === 1 ? 'voto' : 'votos'}`;
      },
    },
    mounted() {
      if (this.hasAlreadyVoted()) {
        this.afterVoteMessage = this.thanksText;
        this.activeOption = parseInt(Cookies.get(this.votedPollCookieName));
      }
    }
  }
</script>
